import React from "react"
import ReactCalendar from 'react-calendar'
import { ChevronLeft, ChevronRight } from "react-feather"
import moment from 'moment'
import PropTypes from "prop-types"
import {checkDate} from '../../../lib/timetable'

import './Reservation.Calendar.less'

const deletePreviousHours = (dayCursor, times) => {
  if (moment(dayCursor).isSame(moment(), 'day')) {
    return times.filter(hour => moment().format('HH:mm') < hour)
  }
  else return times
}

export default class Calendar extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { }
  }

  render() {
    const {timetable, onChange, value} = this.props
    return  (
      <div style={{marginTop: "2vh", display: "flex", justifyContent: "center"}}>
        <ReactCalendar
          minDate={new Date()}
          value={value}
          locale="zh-CN"
          nextLabel={<ChevronRight color="#969696" size="24px" />}
          prevLabel={<ChevronLeft color="#969696" size="24px" />}
          tileContent={({ date, view }) => (view === 'month' && moment(date).isSame(Date.now(), 'day') ? <p>今天</p> : null)}
          onClickDay={date => onChange(date)}
          minDetail="month"
          tileDisabled={({_activeStartDate, date, _view }) => {
            const schOrExp = checkDate(timetable, date)
            return !schOrExp.open || (!timetable.allDay && deletePreviousHours(date, schOrExp.times).length == 0)
          }}
        />
      </div>
    )
  }
}

Calendar.propTypes = {
  timetable: PropTypes.object.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/Reservation.Calendar.jsx